module.exports = __webpack_public_path__ + "84aba535b5d272d4f5e4fe937a632464.pdf";